import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

type SFVisibilityIconProps = Omit<SvgIconProps, "color"> & {
  color?: string;
};

export default function SFVisibilityIcon({ color, ...props }: SFVisibilityIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 12.9944C20.861 8.32907 16.756 5 12.0007 5C7.24329 5 3.137 8.33194 2 13"
          stroke="#C1C1C1"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle cx="12" cy="14" r="4" stroke="#C1C1C1" strokeWidth="2" />
      </svg>
    </SvgIcon>
  );
}
